/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './BookableSlotForm.css';

import {
} from '../../actions';


class BookableSlotForm extends OzFormComponent {

  static fields = [
    'workflow',
    'slotsBooked',
  ];

  renderBody() {
    let workflowOptions = [
      ['available', 'Available'],
      ['booked', 'Booked'],
    ];

    let bookableSlot = this.props.bookableSlot;
    let slotsBookedOptions = [];
    let min = bookableSlot.room.minPeople;
    let max = bookableSlot.room.maxPeople;
    slotsBookedOptions.push([0, 0 + '/' + max + ' booked']);
    for (let i = min; i <= max; i++) {
      slotsBookedOptions.push([i, i + '/' + max + ' booked']);
    }

    return (
      <div className="BookableSlotForm">
        {this.renderFormGroup('Booking status', 'pills', 'workflow', workflowOptions, { helptext: 'Is this time slot available to book?' })}
        {this.renderFormGroup('Number of slots booked', 'select', 'slotsBooked', slotsBookedOptions, { helptet: 'How many slots are currently booked?'})}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BookableSlotForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/BookableSlotForm.js
 **/